import _ from 'lodash';

const analyticsTypes = {
  INTEGRATION_ENROLL_CLICK: 'integrations_EnrollClick',
  INTEGRATION_SYNC_SUPPLIER: 'integrations_SyncSupplier',
  INTEGRATION_SUPPLIER_DETAILS: 'integrations_SupplierDetails',
  INTEGRATION_LANDING_PAGE: 'integrations_LandingPage',
};

const extractEnrollmentDetails = (supplier, extra) => ({
  supplier_id: _.get(supplier, 'id'),
  supplier_name: _.get(supplier, 'short_name'),
  ...extra
});

const analyticsActions = [{
  type: analyticsTypes.INTEGRATION_ENROLL_CLICK,
  attributesExtractor: extractEnrollmentDetails,
}, {
  type: analyticsTypes.INTEGRATION_SYNC_SUPPLIER,
  attributesExtractor: extractEnrollmentDetails,
}, {
  type: analyticsTypes.INTEGRATION_SUPPLIER_DETAILS,
  attributesExtractor: extractEnrollmentDetails,
}, {
  type: analyticsTypes.INTEGRATION_LANDING_PAGE,
}];

export {
  analyticsTypes,
  analyticsActions
};
